import { FormControlLabel, RadioGroup, Radio, FormLabel } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';
import React, { memo, useEffect, useRef } from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { useLang } from '../../../util/lang';

// Renders a React Hook Form radio group with an optional persistent required indicator.
const RadioRhf = ({
    question,
    name,
    formControlLabelRhf,
    defaultValue = '',
    row = true,
    ImageComponent = <></>,
    resetFieldObject = { condition: false, name: '', monitorName: '' },
    revalidateObject = { condition: false, name: '', monitorName: '' },
    alwaysShowRequired = false,
    disabled = false,
    clearWhenDisabled = false,
}) => {
    const {
        formState: { errors },
        control,
        resetField,
        watch,
        trigger,
        getValues,
        setValue,
    } = useFormContext();
    const disabledValueRef = useRef(undefined);
    const wasDisabledRef = useRef(false);

    // Explain: reset the field
    useEffect(() => {
        if (resetFieldObject.condition) {
            resetField(resetFieldObject.name, { defaultValue: '' });
        }
    }, [watch(resetFieldObject?.monitorName)]);

    // Explain: trigger to revalidate the field
    useEffect(() => {
        if (revalidateObject.condition) {
            trigger(revalidateObject.name);
        }
    }, [watch(revalidateObject.monitorName)]);

    useEffect(() => {
        const shouldClear = clearWhenDisabled && disabled;
        if (shouldClear && !wasDisabledRef.current) {
            disabledValueRef.current = getValues(name);
            resetField(name, { defaultValue: '' });
        } else if (!shouldClear && wasDisabledRef.current && disabledValueRef.current !== undefined) {
            setValue(name, disabledValueRef.current, { shouldValidate: true });
            disabledValueRef.current = undefined;
        }
        wasDisabledRef.current = shouldClear;
    }, [clearWhenDisabled, disabled, name, getValues, resetField, setValue]);

    return (
        <div id={name}>
                <FormLabel
                    component="legend"
                    disabled={disabled}
                    style={{ display: 'flex', alignItems: 'center', color: disabled ? 'rgba(0, 0, 0, 0.38)' : undefined }}
                >
                <span style={{ marginRight: 8, color: disabled ? 'rgba(0, 0, 0, 0.38)' : undefined }}>
                    {question}
                </span>
                {alwaysShowRequired && !disabled ? (
                    <span style={{ color: 'red' }}>*</span>
                ) : (
                    <ErrorMessage
                        errors={errors}
                        name={name}
                        // render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                        render={({ message }) => <span style={{ color: 'red' }}>*</span>}
                    />
                )}
            </FormLabel>
            {ImageComponent && ImageComponent}
            <Controller
                rules={{ required: true }}
                control={control}
                name={name}
                render={({ field }) => (
                    <RadioGroup {...field} row={row} disabled={disabled}>
                        <>{formControlLabelRhf}</>
                    </RadioGroup>
                )}
                defaultValue={defaultValue}
            />
            {/* <div style={{ marginLeft: 8 }}>
                <ErrorMessage
                    errors={errors}
                    name={name}
                    render={({ message }) => <div style={{ color: 'red' }}>{message}</div>}
                />
            </div> */}
        </div>
    );
};

export default memo(RadioRhf);
